import script from "./MensagemResultado.vue?vue&type=script&setup=true&lang=js"
export * from "./MensagemResultado.vue?vue&type=script&setup=true&lang=js"

import "./MensagemResultado.vue?vue&type=style&index=0&id=4239d8de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4239d8de"]])

export default __exports__